import { useGetApi } from '../../shared/hooks/fetchingHooks';

export const useLocalesList = () => useGetApi('/api/locales', []);

export default useLocalesList;
